module.exports = "/fast-coin/img/coin/anim/shine_1/shine_1_010.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_1/shine_1_010.png
// module id = 2326
// module chunks = 5